import { Actions } from './types';
import { KeyboardLayoutType, CandidatesKeyboard, isSpecialKey } from '../../../utils/KeyUtils';
import { SCREEN_LAYOUTS } from './utils';
import {
  isScreenSwitchAction,
  switchScreen,
  isCycleModifierAction,
  cycleModifier,
  isBracketsAction,
  insertBracket,
  isSpecialAction,
  handleSpecialAction,
  isKatakanaSwitchAction,
  toggleKana,
  isZenkakuAction,
  toggleZenkaku,
  getZenkakuMode,
  restoreDefaultButtonTheme,
} from './actions';
import { toFullWidth } from 'components/Keyboard/Custom/Japanese/modules/zenkaku';
import { SPECIAL_KEYS } from 'components/Keyboard/utils/constants';

const ACTIONS: Array<Actions> = [
  [isScreenSwitchAction, switchScreen],
  [isZenkakuAction, toggleZenkaku],
  [isSpecialAction, handleSpecialAction],
  [isCycleModifierAction, cycleModifier],
  [isBracketsAction, insertBracket],
  [isKatakanaSwitchAction, toggleKana],
];

const japaneseModule = (initialLayout = SPECIAL_KEYS.KANA) => (keyboard: CandidatesKeyboard) => {
  keyboard.registerModule('japanese', (module: any) => {
    module.fn = {
      handleButtonClicked: keyboard.handleButtonClicked,
    };

    // Override layoutType to Japanese layout
    keyboard.setOptions({
      layoutName: 'default',
      layoutType: KeyboardLayoutType.DEFAULT,
      layout: SCREEN_LAYOUTS[initialLayout],
    });

    restoreDefaultButtonTheme(keyboard);

    keyboard.handleButtonClicked = (...args) => {
      const [button] = args;

      for (const [buttonCondition, action] of ACTIONS) {
        if (buttonCondition(button)) {
          return action(button, keyboard);
        }
      }

      // Emoticon key: pass display value to candidates module
      if (button === SPECIAL_KEYS.KAOMOJI) {
        return module.fn.handleButtonClicked.call(keyboard, '^^');
      }

      // Full-width conversion when zenkaku mode is active
      if (getZenkakuMode(keyboard) && !isSpecialKey(button)) {
        return module.fn.handleButtonClicked.call(keyboard, toFullWidth(button));
      }

      return module.fn.handleButtonClicked.call(keyboard, ...args);
    };
  });
};

export default japaneseModule;
